module.exports = __webpack_public_path__ + "img/art_5_3.09c69093.jpg";